<form novalidate *ngIf="!wizardCtrl.getWizardService().isLoading"
      #currentForm="ngForm">
      <div class="group">
        <p class="label">URL *</p>
        <input autocomplete="off" matInput class="hostname" name="url" placeholder="Enter URL"
               [(ngModel)]="url"
               #urlInput="ngModel"
               (ngModelChange)="urlUpdated()"
               maxlength="50"
               required/>
        <div class="error" *ngIf="urlInput.invalid && (urlInput.dirty || urlInput.touched)">
          <mat-error *ngIf="urlInput.errors.maxlength">URL is too long</mat-error>
          <mat-error *ngIf="urlInput.errors.required">URL is required</mat-error>
        </div>
        <div class="error" *ngIf="!isValidMsg">
          Not a valid URL
        </div>
    </div>
    <div class="group">
        <p class="label">Username *</p>
        <input autocomplete="off" matInput class="username" name="username" placeholder="Enter username"
               [(ngModel)]="username"
               #usenameInput="ngModel"
               (ngModelChange)="usernameUpdated()"
               maxlength="30"
               required/>
        <div class="error" *ngIf="usenameInput.invalid && (usenameInput.dirty || usenameInput.touched)">
          <mat-error *ngIf="usenameInput.errors.maxlength">Username is too long</mat-error>
          <mat-error *ngIf="usenameInput.errors.required">Username is required</mat-error>
        </div>
    </div>
    <div class="group">
        <p class="label">Password *</p>

        <input matInput class="password" name="password" placeholder="Enter password"
               [(ngModel)]="password"
               #passwordInput="ngModel"
               required
               (ngModelChange)="passwordUpdated()"
               [type]="hide ? 'password' : 'text'"
               />
        <div class="visibility-toggler">
            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </div>
        <div class="error" *ngIf="passwordInput.invalid && (passwordInput.dirty || passwordInput.touched)">
          <mat-error *ngIf="passwordInput.errors.required">Password is required</mat-error>
        </div>
    </div>
</form>
<div *ngIf="wizardCtrl.getWizardService().isLoading" class="loader">
  <div class="loader-msg-header">
    <p>Saving InfoBlox configuration</p>
  </div>
  <mat-spinner></mat-spinner>
  <p class="loader-msg">One moment...</p>
</div>
